import Vue from 'vue'
import VueResource from 'vue-resource'
import VueMoment from 'vue-moment'
import DatePicker from 'vue2-datepicker'

import App from './App.vue'
import router from './router'
import store from './store'
import VueFlashMessage from 'vue-flash-message';
import VueTheMask from 'vue-the-mask';
import money from 'v-money';

import 'datatables.net';

Vue.use(VueResource)
Vue.use(VueMoment);
Vue.use(DatePicker);
Vue.use(VueTheMask)
Vue.use(money, { precision: 2 })

Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 4000
  }
});

Vue.config.productionTip = false
Vue.http.options.root = process.env.BASE_URL
Vue.http.options.withCredentials = true

import 'vue-flash-message/dist/vue-flash-message.min.css'
import '../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css';  // DataTables CSS


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')